import { hasListener } from '@client/selectors/helpers/listeners';
import { startFetchShowProducts } from '@client/slices/entities/products.reducer';
import { startFetchFullShow, startFetchMinimalShow, upsertShowMetadata } from '@client/slices/entities/shows.reducer';
import { addFirestoreListener } from '@client/slices/helpers/listeners.reducer';
import type { AddListener } from '@client/listeners/lib';

export const withShowListeners = (addListener: AddListener) => [
  addListener({
    actionCreator: startFetchMinimalShow,
    effect: (action, listenerApi) => {
      const showId = action.payload;
      const firebase = window.Firebase;

      const state = listenerApi.getState();
      const { dispatch } = listenerApi;

      firebase.SDK.Shows.listen(showId, null, { modifier: { publicFetched: true } });

      firebase.SDK.Shows.Private().listen(showId, null, { modifier: { privateFetched: true } });

      const profileListenerName = `list-show-profiles-${showId}`;
      const profileListener = hasListener(state, profileListenerName);

      if (!profileListener) {
        const watchListener = firebase.SDK.Shows.PublicProfiles(showId).watch({});

        dispatch(addFirestoreListener({ watchListener, name: profileListenerName }));
      }

      const privateProfileListenerName = `list-show-private-profiles-${showId}`;
      const privateProfileListener = hasListener(state, privateProfileListenerName);

      if (!privateProfileListener) {
        const watchListener = firebase.SDK.Shows.Private().PrivateProfiles(showId).watch({});

        dispatch(addFirestoreListener({ watchListener, name: privateProfileListenerName }));
      }
    },
  }),

  addListener({
    actionCreator: startFetchFullShow,
    effect: (action, listenerApi) => {
      const showId = action.payload;
      const firebase = window.Firebase;

      const state = listenerApi.getState();
      const { dispatch } = listenerApi;

      dispatch(startFetchShowProducts(showId));
      firebase.SDK.Shows.listen(showId, null, { modifier: { publicFetched: true } });

      firebase.SDK.Shows.Private().listen(showId, null, { modifier: { privateFetched: true } });

      firebase.SDK.Shows.Metadata(showId).Tickets().listen(null, (ticketsMetadata) => {
        dispatch(upsertShowMetadata(ticketsMetadata));
      });

      firebase.SDK.Shows.Metadata(showId).Orders().listen(null, (ordersMetadata) => {
        dispatch(upsertShowMetadata(ordersMetadata));
      });

      const profileListenerName = `list-show-profiles-${showId}`;
      const profileListener = hasListener(state, profileListenerName);

      if (!profileListener) {
        const watchListener = firebase.SDK.Shows.PublicProfiles(showId).watch({});

        dispatch(addFirestoreListener({ watchListener, name: profileListenerName }));
      }

      const privateProfileListenerName = `list-show-private-profiles-${showId}`;
      const privateProfileListener = hasListener(state, privateProfileListenerName);

      if (!privateProfileListener) {
        const watchListener = firebase.SDK.Shows.Private().PrivateProfiles(showId).watch({});

        dispatch(addFirestoreListener({ watchListener, name: privateProfileListenerName }));
      }

      const affiliatesListener = hasListener(state, `list-show-affiliates-${showId}`);

      if (!affiliatesListener) {
        const watchListener = firebase.SDK.Shows.Affiliates(showId).watch({});
        dispatch(addFirestoreListener({ watchListener, name: `list-show-affiliates-${showId}` }));
      }
    },
  }),
];
